var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('listado-secciones-tabla',{attrs:{"data":_vm.dataDatatable,"lista_modulos":_vm.listaModulos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }